// import redux
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "./../features/store";
import {itemReviewCloseAction} from "./../features/sliceReducer/interactionReducer";

import {useForm, Controller} from "react-hook-form";

//import material-UI
import {makeStyles, createStyles, Theme} from "@material-ui/core/styles";
import {
  Modal,
  Fade,
  Backdrop,
  Box,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  Typography,
  TextField,
  IconButton,
} from "@material-ui/core";

import CloseIcon from "@material-ui/icons/Close";
import SaveIcon from "@material-ui/icons/Save";
import DeleteIcon from "@material-ui/icons/Delete";
import BackupIcon from "@material-ui/icons/Backup";
import BorderColorIcon from "@material-ui/icons/BorderColor";
import {initializeIPItemReview, IPItemReview} from "../models/IPItemReview";
import {useEffect, useState} from "react";
import IPUtility from "../classes/IPUtility";
//material-UI-Style

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    modal: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    paper: {
      width: "600px",
      border: `2px solid #4f5470`,
      boxShadow: theme.shadows[5],
    },

    table: {
      // minWidth: 650,
      // border: "1px solid #9e9e9e",
      "& td": {
        padding: "12px",
        // border: "1px solid #9e9e9e",
      },
    },
    // buttonCell: {
    //   display: "flex",
    //   justifyContent: "space-around",
    //   border: "1px solid #dbdce0",
    // },
    modalTitle: {
      padding: "12px 16px",
      textAlign: "center",
      fontSize: "20px",
      fontWeight: "bold",
      backgroundColor: "#4f5470",
      color: "white",
      "& h5": {
        display: "flex",
        alignItems: "center",
        "& svg": {
          paddingRight: "8px",
        },
      },
      "& span": {
        fontSize: "18px",
        fontWeight: "normal",
      },
    },
    searchInput: {
      display: "flex",
      justifyContent: "center",
      marginBottom: " 20px",
    },

    // buttonStyle: {
    //   display: "flex",
    //   justifyContent: "center",

    //   "& button": {
    //     width: "200px",
    //     height: "40px",
    //     marginTop: "80px",
    //   },
    // },
    inputStyle: {
      backgroundColor: theme.palette.input.main,
    },
    imageBox: {
      width: "100%",
      height: "300px",
      padding: "12px",
      textAlign: "center",
      border: "1px solid #dbdce0",
      backgroundColor: theme.palette.input.main,
      "& img": {
        height: "100%",
      },
    },
    cell: {
      border: "1px solid #dbdce0",
    },

    buttonContainer: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "12px 20px",
    },
  })
);

// note 2022-02-04 SmokingScully 추가
interface ItemReviewModelProps {
  itemReview: IPItemReview;
  updateHandler: (value: IPItemReview) => void;
}

const ItemReviewModal = (props: ItemReviewModelProps) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [imgSrc, setImgSrc] = useState("");
  const [fileName, setFileName] = useState("");
  // const [base64, setBase64] = useState("");

  const {itemReviewModalToggle} = useSelector((state: RootState) => state.interaction);

  const {
    reset,
    getValues,
    control,
    formState: {errors},
  } = useForm();

  // const onSubmit = (data) => console.log(data);

  useEffect(() => {
    reset({...props.itemReview});
    if (props.itemReview.base64 && props.itemReview.base64.length > 0) {
      setImgSrc(props.itemReview.base64);
    } else if (props.itemReview.fileName && props.itemReview.fileName.length > 0) {
      setImgSrc("/uploads/inspect/reviewImages/" + props.itemReview.fileName);
    } else setImgSrc("");
    setFileName(props.itemReview.fileName);
  }, [props]);

  // note ImageLoaded - 2022-02-04 추가
  const imageLoaded = (e: React.ChangeEvent<HTMLInputElement>) => {
    IPUtility.imageLoadedHandler(e, setImgSrc, setFileName, 640, 480);

    // e.preventDefault();
    // const fileList = e.target.files;
    // if (fileList !== undefined && fileList !== null && fileList.length > 0) {
    //   var file = fileList[0];
    //   IPUtility.getFile(file).then((fileInfoData) => {
    //     const fileName = fileInfoData.fileName;
    //     const base64 =
    //       "data:" +
    //       fileInfoData.fileType +
    //       ";base64," +
    //       fileInfoData.base64StringFile;
    //     setImgSrc(base64);
    //     setBase64(base64);
    //     setFileName(fileName);
    //   });
    // }
  };

  const SaveReview = () => {
    const newReview = {...props.itemReview};
    newReview.review = getValues("review");
    newReview.base64 = imgSrc;
    newReview.fileName = fileName;
    props.updateHandler(newReview);
    dispatch(itemReviewCloseAction());
  };

  const DeleteReview = () => {
    const newReview = {
      ...initializeIPItemReview,
      uid: props.itemReview.uid,
      // itemUID: props.itemReview.itemUID,
      projectUID: props.itemReview.projectUID,
    };
    props.updateHandler(newReview);
    dispatch(itemReviewCloseAction());
  };

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className={classes.modal}
      open={itemReviewModalToggle}
      onClose={() => {
        dispatch(itemReviewCloseAction());
      }}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={itemReviewModalToggle}>
        <TableContainer component={Paper} className={classes.paper}>
          <Box
            className={classes.modalTitle}
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography variant="h5" component="h5">
              <BorderColorIcon />
              {props.itemReview.isMeeting ? "면담사진" : "현 실태 및 문제점"}
            </Typography>
            <IconButton aria-label="close" onClick={() => dispatch(itemReviewCloseAction())}>
              <CloseIcon style={{color: "white", fontWeight: "bold"}} />
            </IconButton>
          </Box>
          <Box p="16px">
            <Table className={classes.table} aria-label="simple table">
              <TableBody>
                <TableRow>
                  <TableCell className={classes.cell}>
                    <Controller
                      name="review"
                      control={control}
                      defaultValue={props.itemReview.review}
                      render={({field}) => (
                        <TextField
                          {...field}
                          className={classes.inputStyle}
                          multiline
                          rows={4}
                          fullWidth
                          variant="outlined"
                          margin="dense"
                          error={errors.name ? true : false}
                        />
                      )}
                    />
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className={classes.cell}>
                    <div className={classes.imageBox}>{imgSrc && <img src={imgSrc} alt="" />}</div>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className={classes.cell}>
                    <span>파일명 : {fileName} </span>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className={classes.cell}>
                    <Box className={classes.buttonContainer}>
                      <input
                        accept="image/*"
                        capture="camera"
                        onChange={imageLoaded}
                        style={{display: "none"}}
                        id="icon-button-photoImage"
                        type="file"
                      />
                      <label htmlFor="icon-button-photoImage">
                        <IconButton color="primary" aria-label="upload picture2" component="span">
                          <BackupIcon />
                        </IconButton>
                      </label>
                      {/* <Button
                        variant="contained"
                        color="secondary"
                        startIcon={<ListIcon />}
                      >
                        첨부
                      </Button> */}
                      <div>
                        <Button
                          variant="contained"
                          color="primary"
                          startIcon={<SaveIcon />}
                          onClick={SaveReview}
                        >
                          저장
                        </Button>
                        <Button
                          style={{marginLeft: "12px"}}
                          variant="contained"
                          color="secondary"
                          startIcon={<DeleteIcon />}
                          onClick={DeleteReview}
                        >
                          삭제
                        </Button>
                      </div>
                    </Box>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Box>
        </TableContainer>
      </Fade>
    </Modal>
  );
};

export default ItemReviewModal;
